<template>
  <!-- accept="image/jpeg,image/png,application/pdf,application/vnd.ms-powerpoint,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation" -->
  <div class="upload pointer">
    <input
      type="file"
      name="file"
      class="fileUpload"
      @change="fileChange"
      title=" "
      id="fileUpload"
      ref="fileUpload"
      accept=".xls,.xlsx"
    />
    <a href="javascript:;" class="uploadButton" @click="getFile">{{
      $t("luckDaw.上传名单")
    }}</a>
  </div>
</template>
<script>
/* eslint-disable */
import { uploadUser } from "@/api/liveRequest/luckDawApi";
export default {
  name: "upload",
  components: {},
  props: {
    uploadtype: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      // fileName: ""
    };
  },
  methods: {
    fileChange() {
      let files = document.getElementById("fileUpload").files;
      console.log(files, "files");
      //   this.fileName = files[0].name;
      this.$emit("update:fileName", files[0].name);
      this.upload(files[0]);
    },
    getFile() {
      document.getElementById("fileUpload").click();
    },
    async upload(file) {
      let fd = new FormData();
      fd.append("file", file);
      const { success, data } = await uploadUser(fd);
      console.log(success);
      if (success) {
        this.$message({
          message: this.$t("upload.成功导入") + data + this.$t("upload.条用户"),
          type: "success",
        });
        this.$emit("update:total", data);
        this.$emit("changeUser", null);
      } else {
        this.$message({
          message: this.$t('upload.上传失败'),
          type: "error",
        });
      }
    },
  },
  computed: {},
};
</script>

<style scoped lang="scss">
// .upload {
//   position: relative;
// }
.fileUpload,
.uploadButton {
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  display: inline-block;
  width: 70px;
  height: 28px;
  //   border: 1px solid $blue-color;
  text-align: center;
  border-radius: 6px;
  color: $white-color;
  font-size: 12px;
  line-height: 28px;
  font-weight: normal;
  text-decoration: none;
  background: $bule-color;
}
.fileUpload {
  opacity: 0;
}
.uploadButton {
  z-index: 1;
  &:hover {
    background: $bule-color;
    color: $white-color;
  }
  &:active {
    background: $bule-color;
  }
}
.btnDownload {
  width: 1.09375rem;
  height: 0.875rem;
  margin-right: 0.3125rem;
}
</style>
